import { render } from "./DetailSubCategoryView.vue?vue&type=template&id=00b99f24"
import script from "./DetailSubCategoryView.vue?vue&type=script&lang=js"
export * from "./DetailSubCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__